export default __webpack_public_path__ + "static/media/pvilla2-3.7fc9d8d2.webp";